import { render, staticRenderFns } from "./DashboardGraph.vue?vue&type=template&id=87a4ac08&scoped=true&"
import script from "./DashboardGraph.vue?vue&type=script&lang=js&"
export * from "./DashboardGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a4ac08",
  null
  
)

export default component.exports